function ez_mobileAside(width) {

    const aside     = $('._js-mobile-aside');
    const nav       = $('#_js-navigation');
    const location  = $('#_js-header-location');
    const contacts  = $('#_js-header-contacts');
    const controls  = $('#_js-header-controls');
    const trigger   = $('._js-aside-trigger');
    const wrapper   = $('._js-website-wrapper');

    trigger.on('click', function(){
        if ( !$(this).hasClass('_active') ) {
            $(this).addClass('_active');
            ez_websiteWidth();
            wrapper.addClass('_mobile-aside-opened');
        }
        else {
            $(this).removeClass('_active');
            wrapper.removeClass('_mobile-aside-opened').css('max-width', '');
        }
    });

    $(window).on('load resize', function(){
        const screen    = $(window).width();

        if ( screen <= width ) {

            if ( !aside.find(nav).length ) {
                aside.append(nav);
            }
            if ( !aside.find(location).length ) {
                aside.append(location);
            }
            if ( !aside.find(contacts).length ) {
                aside.append(contacts);
            }
        }
        else {

            trigger.removeClass('_active');
            wrapper.removeClass('_mobile-aside-opened').css('max-width', '');

            if ( !controls.find(nav).length ) {
                nav.insertBefore(controls);
            }
            if ( !controls.find(contacts).length ) {
                controls.prepend(contacts);
            }
            if ( !controls.find(location).length ) {
                controls.prepend(location);
            }

        }
    });

}